"use client";

import Link from "next/link";
import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import FeatureSkeleton from "./_skeletons/FeatureSkeleton";
import Image from "next/image";
import { motion } from "framer-motion";

export const Feature = () => {
  const { trans } = useUtility();
  const { content, elements, loading } = useSection("feature");

  if (loading) {
    return <FeatureSkeleton />;
  }

  return (
    <motion.section
      className="finance-hub-section py-100 section-bg"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      <div className="container">
        {/* Section Heading */}
        <motion.div
          className="row justify-content-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <div className="col-xl-10">
            <div className="section-heading text-center">
              <span className="section-heading__subtitle">
                {trans(content?.subheading)}
              </span>
              <motion.h2
                className="section-heading__title gradient-text mb-0"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2 }}
              >
                Centralized financial gateway: <br />
                Your Financial Hub
              </motion.h2>
            </div>
          </div>
        </motion.div>

        {/* Feature Items */}
        <div className="row justify-content-center gy-3">
          {elements?.map((item, index) => {
            // Image URL
            const iconUrl = item?.icon
              ? `${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/feature/${item.icon}`
              : null;

            // Button link handling
            const buttonLink = item?.button_link || "#";

            return (
              <motion.div
                key={index}
                className="col-md-6"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.3 + index * 0.15 }}
              >
                <div
                  className={`finance-hub-item text-center ${index % 2 !== 0 ? "two" : ""}`}
                >
                  <span className="finance-hub-item__thumb">
                    <Image
                      src={iconUrl}
                      alt="Feature Icon"
                      width={321}
                      height={331}
                    />
                  </span>
                  <h5 className="finance-hub-item__title gradient-text">
                    {trans(item?.title)}
                  </h5>
                  <p className="finance-hub-item__desc">
                    {trans(item?.description)}
                  </p>
                  <Link
                    href={buttonLink}
                    className={`btn btn--warning ${index === 0 ? "finance-hub-item__button" : "finance-hub-item__button-2"}`}
                  >
                    {trans(item?.button_text)}{" "}
                    <i className="las la-arrow-right"></i>
                  </Link>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.section>
  );
};
